import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

const StyledLink = styled.a`
  color: ${props => props.theme.colors.merciless};
  transition: color 0.2s ease-in;

  &:hover {
    color: ${props => props.theme.colors.briangerine};
  }
`;

export const StyledButton = styled.a``;

export const Button = props => {
  /**
   * Determine if a link is external by constructing a URL object from the prop,
   * then comparing the hostname of the URL with the window's hostname. If the
   * `href` prop is a relative link like '/test', the window.location will be
   * used as a base. If it's an absolute URL like 'https://google.com', the base
   * will be ignored
   */
  const isExternal =
    new URL(props.href, window.location).hostname !== window.location.hostname;

  // TODO: refactor Button and StyledLink to reuse logic
  const attrs = isExternal
    ? /** Add extra attributes for external links */
      {
        href: props.href,
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : /** Internal Link components need the "to" prop instead of "href" */
      {
        to: props.href,
      };

  return (
    <StyledButton
      {...props}
      {...attrs}
      as={isExternal ? undefined : Link}
      className={props.className}
    />
  );
};

export default props => {
  /**
   * Determine if a link is external by constructing a URL object from the prop,
   * then comparing the hostname of the URL with the window's hostname. If the
   * `href` prop is a relative link like '/test', the window.location will be
   * used as a base. If it's an absolute URL like 'https://google.com', the base
   * will be ignored
   */
  const isExternal = props.hasOwnProperty(`isExternal`)
    ? props.isExternal
    : new URL(props.href, window.location).hostname !==
      window.location.hostname;

  const attrs = isExternal
    ? /** Add extra attributes for external links */
      {
        href: props.href,
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : /** Internal Link components need the "to" prop instead of "href" */
      {
        to: props.href,
      };

  return (
    <StyledLink
      {...props}
      {...attrs}
      /** If the link is internal, use a react-router Link */
      as={isExternal ? undefined : Link}
    />
  );
};
